import { render, staticRenderFns } from "./DecoProperties.vue?vue&type=template&id=62de0fd8&"
import script from "./DecoProperties.vue?vue&type=script&lang=ts&"
export * from "./DecoProperties.vue?vue&type=script&lang=ts&"
import style0 from "./DecoProperties.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports